// extracted by mini-css-extract-plugin
export default {"button":"ConfirmationPayment__button___wTPTZ","lastButton":"ConfirmationPayment__lastButton___vr8bq","echeckMessage":"ConfirmationPayment__echeckMessage___swwMP"};